import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { TOrderFormValues } from '../../OrderForm.types';

export const OrderFormFlagsSection: React.FC = () => {
  const localize = useLocalize();
  const { control } = useFormContext<TOrderFormValues>();

  return (
    <section className="admin-orders-detail__section">
      <h3 className="h6 admin-orders-detail__section-title">
        {localize('admin.orders.detail.section.flags')}
      </h3>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="receiveNotifications"
            control={control}
            render={({ field }) => (
              <label className="admin-order-form__checkbox-row body2">
                <input
                  type="checkbox"
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
                <span>
                  {localize('admin.orders.detail.label.receive.notifications')}
                </span>
              </label>
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="policyAccepted"
            control={control}
            render={({ field }) => (
              <label className="admin-order-form__checkbox-row body2">
                <input
                  type="checkbox"
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
                <span>{localize('admin.orders.detail.label.policy')}</span>
              </label>
            )}
          />
        </div>
      </div>
    </section>
  );
};
